var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesforce20X15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32278 1.55332C8.9678 0.869549 9.86581 0.445476 10.8589 0.445476C12.1792 0.445476 13.3311 1.19449 13.9444 2.30639C14.4931 2.05704 15.0874 1.92852 15.6883 1.92926C18.0696 1.92926 20 3.91039 20 6.35426C20 8.79829 18.0696 10.7794 15.6883 10.7794C15.3977 10.7794 15.1137 10.7499 14.8391 10.6933C14.2988 11.6736 13.2695 12.336 12.088 12.336C11.6102 12.3366 11.1386 12.2261 10.7092 12.0131C10.1616 13.3235 8.88577 14.2424 7.39881 14.2424C5.85039 14.2424 4.53079 13.2455 4.02419 11.8476C3.80287 11.8954 3.5735 11.9204 3.33819 11.9204C1.49463 11.9204 8.54933e-06 10.384 8.54933e-06 8.48879C-0.00131951 7.88813 0.152102 7.2976 0.444983 6.77605C0.737864 6.25451 1.15998 5.82016 1.66926 5.5163C1.45778 5.021 1.34895 4.48667 1.34956 3.94667C1.34956 1.76695 3.08888 0 5.2343 0C6.49384 0 7.61324 0.609297 8.32286 1.55332",
    fill: "#00A1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce20X15);
export default __webpack_public_path__ + "97131/static/media/Salesforce20x15.40f70ef08758f2fe1e998c4521ff1275.svg";
export { ForwardRef as ReactComponent };